export const iconFontAwesomeConstructionArrowUpFromGroundWater = (
	<i className="fa-solid fa-arrow-up-from-ground-water"></i>
);
